import {HttpClient} from "../../service/httpClient/HttpClient";
import axios from "axios";

export class SliderService {

    constructor() {
        this.httpClient = new HttpClient()
    }

    getSliderList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `sliders`,
                {
                    page, size
                }
            ).then(resolve).catch(reject)
        })
    }

    getSliderTypes() {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `sliders/types`
            ).then(resolve).catch(reject)
        })
    }

    addNewSlider(sliderType) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `sliders`,
                {
                    sliderType
                }
            ).then(resolve).catch(reject)
        })
    }

    getSliderDetail(id) {

        const globalInfo = this.httpClient.get(
            `sliders/${id}`
        );
        const publishInfo = this.httpClient.get(
            `sliders/${id}/published`
        );

        const requests = [globalInfo, publishInfo]

        return new Promise((resolve, reject) => {
            axios.all(requests)
                .then(axios.spread((info, publish) => {
                    resolve({
                        info,
                        publish
                    })
                })).catch(reject)
        })
    }

    addNewSliderItem(id, title, shortDescription, link) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `sliders/${id}/items`,
                {
                    shortDescription,
                    title,
                    link
                }
            ).then(resolve).catch(reject)
        })
    }

    updateSliderPublishState(id, published) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `sliders/${id}/published`,
                {},
                {
                    published
                }
            ).then(resolve).catch(reject)
        })
    }

    getSliderItemsList(id, page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `sliders/${id}/items/`,
                {
                    page, size
                }
            ).then(resolve).catch(reject)
        })
    }

    getSliderItemDetail(id) {
        const globalInfoRequest = this.httpClient.get(
            `sliders/items/${id}/information`
        )

        const thumbnailRequest = this.httpClient.get(
            `sliders/items/${id}/thumbnails`
        )

        const publishStateRequest = this.httpClient.get(
            `sliders/items/${id}/published`
        )

        const requests = [globalInfoRequest, thumbnailRequest, publishStateRequest]


        return new Promise((resolve, reject) => {
            axios.all(requests)
                .then(axios.spread((globalInfo, thumbnail, published) => {
                    resolve({
                        globalInfo,
                        thumbnail,
                        published
                    })
                })).catch(reject)
        })
    }

    updateSliderItemGlobalInfo(id, title, link, shortDescription) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `sliders/items/${id}/information`,
                {
                    shortDescription,
                    title,
                    link
                }
            ).then(resolve).catch(reject)
        })
    }

    updateSliderItemThumbnail(id, file) {
        let data = new FormData()
        data.append('file', file)

        return new Promise((resolve, reject) => {
            new HttpClient(
                {},
                "multipart/form-data"
            ).patch(
                `sliders/items/${id}/thumbnails`,
                {},
                data
            ).then(resolve).catch(reject)
        })
    }

    updateSliderItemPublishState(id, published) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `sliders/items/${id}/published`,
                {},
                {
                    published
                }
            ).then(resolve).catch(reject)
        })
    }
}


export const sliderTypes = {
    LANDING_SLIDER: {
        id: "LANDING",
        title: "صفحه اصلی",
        icon: "ic-game-play"
    }, POSTS_SLIDER: {
        id: "POSTS",
        title: "اخبار",
        icon: "ic-game-play"
    }, MULTI_MEDIA_SLIDER: {
        id: "MULTI_MEDIA",
        title: "چند رسانه‌ای",
        icon: "ic-game-play"
    }, GALLERY_SLIDER: {
        id: "GALLERY",
        title: "گالری تصاویر",
        icon: "ic-game-play"
    },
}